<template>
    <div class="visitlists">
      <div class="search">
        <div class="btns">
          <!-- 搜索框 -->
          <!-- <van-search class="search-bar"
                      v-model="searchText"
                      placeholder="请输入用户名/姓名"
                      shape="round"
                      @search="onSearch"
                      @clear="onSearch">
          </van-search>-->
          <!-- 筛选按钮 -->
          <div class="select-btn flex-center" @click="showSelectCon = !showSelectCon">
          <img :src="require('@/assets/schoolAffairs/shaixuanxuanzhong.svg')" />
          <span style="margin-left: 5px;margin-top: -3px;">筛选</span>
          </div>
        </div>
      </div>
      <office-select-choose-visit v-show="showSelectCon" :setCondition="setCondition" :isFromProps="isFromProps" :interviewStatusSon="interviewStatusSon"></office-select-choose-visit>
      <div v-show="!showSelectCon" >
        <van-pull-refresh v-model="isLoading" class="visitlists-refresh" @refresh="onRefresh">
          <van-list
              class="refreshWrap"
              v-model="isRefresh"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <ul class="visit-list"> 
                <li class="leave-item clearfix" v-for="(item,index) in list" :key="index">
                  <div @click="details(item)">
                    <div class="right">
                      <div class="title">
                        <div class="nowrap tit">
                            参访人：{{item.VisitorName ? item.VisitorName : ''}}</div>
                        <div class="date fr">{{xy.moment(item.CreateTimeStr?item.CreateTimeStr:'').format('YYYY.MM.DD HH:mm')}}</div>
                      </div>
                      <div class="content">
                          <div style="margin:5px 0" v-if="item.VisitStatus === 6 ">
                              <div style="margin:4px 0" v-if="item.ActualVisitInStr && !item.ActualVisitInStr.includes('0001-01-01 00:00')">
                                <span>入校时间：</span>
                                <span>{{xy.moment(item.ActualVisitInStr).format('YYYY-MM-DD')}}</span>
                                <span style="margin-left:8px">{{xy.moment(item.ActualVisitInStr).format('HH:mm')}}</span>
                              </div>
                              <div style="margin:4px 0" v-if="item.ActualVisitOutStr && !item.ActualVisitOutStr.includes('0001-01-01 00:00') ">
                                <span>出校时间：</span>
                                <span>{{xy.moment(item.ActualVisitOutStr).format('YYYY-MM-DD')}}</span>
                                <span style="margin-left:8px">{{xy.moment(item.ActualVisitOutStr).format('HH:mm')}}</span>
                              </div>
                          </div>
                          <div style="margin:5px 0" v-else>
                              <span>预约拜访时间：</span>
                              <span>{{xy.moment(item.ApplicationVisitTimeStr).format('YYYY-MM-DD')}}</span>
                              <span style="margin-left:8px">{{xy.moment(item.ApplicationVisitTimeStr).format('HH:mm')}}</span>
                          </div>
                      </div>    
                      <div class="status" :style="{color: (item.ApprovalStatus === 1 && item.VisitStatus !== 7 ? '#4196FF' : item.ApprovalStatus === 3 ? '#FF602F' : item.ApprovalStatus === 4 ? '#FF602F' : item.VisitStatus === 5 ? '#21A83E' : item.VisitStatus === 6 ? '#E8A022' : item.VisitStatus === 7 ? '#FF602F' : '')}">{{item.visitStatusTxt}}</div>
                    </div>
                  </div>
                </li>
              </ul>
          </van-list>
        </van-pull-refresh>   
      </div>
      <!-- <SingleBottomBtn @clickBtn="onApply" v-if="isShowButtom">预约申请</SingleBottomBtn> -->
    </div>
</template>
<script>
// import SingleBottomBtn from "../../../attendance/components/SingleBottomBtn";
import OfficeSelectChooseVisit from "../../components/OfficeSelectChooseVisit";
export default {
  name:'VisitList',
  data(){
        return{
            isShowSearchBar: false, //搜索框展示
            showSelectCon: false, //筛选下拉框展示
            list:[],
            pageIndex:1,
            PageSize:15,
            total: 0,//总共的数据条数
            isLoading: false, //下拉刷新状态
            isRefresh: false, // 是否加载中
            finished: false, // 加载是否完成
            isShowAgain:true,//是否是第一次申请  为true不是第一次
            isShowButtom:true,//根据权限是否显示预约申请按钮
            isVistGoOutTime:false, //预约/出入校时间
            interviewStatusSon:[],//受访状态
            visitStatusTxt:'',//访问状态名字
            isFromProps:'interview'
       }
    },
    components: {
    //   SingleBottomBtn,
      OfficeSelectChooseVisit
    },
    created() {
     this.interviewStatus()
    },
    methods:{
      //受访状态
      async interviewStatus(){
        this.xy.loading();
        this.showSelectCon = false
        let res = await this.xyapi.get(
           this.xyMApi+'/vst' + "/visitor/GetSearchStatus",
            // "http://localhost:8089" + "/visitor/GetSearchStatus",
        );
        if (res !== undefined && res.success) {
           this.xy.unloading(); 
           this.interviewStatusSon = res.data.map((item)=>{
               return {
                   id:item.Status,
                   name:item.StatusName
               }
           })
           console.log(this.interviewStatusSon )
           
        }
      },   
      // close(){
      //   //返回首页 入口
      //   this.$router.push('/funclist')
      // },
      onApply(){
        this.$router.push({
          path:'/home/VisitApply'
        })
      },
      async onLoad(){
          await this.getList();
          // 加载状态结束
          this.isRefresh = false;
          this.pageIndex++;   
      },
      //下拉加载 
    onRefresh() {
        this.pageIndex = 1;
        this.isLoading = false;
        this.list = []
        if(this.finished){
         this.finished = false;
        }else{
         this.onLoad()
        }
    },
    // 详情
    details(item) {
      console.log(item.VisitorRecordID);
      this.$router.push({
        path: "/home/visitDetails",
        query: {
          VisitorRecordID:item.VisitorRecordID
        }
      });
    },
    async getList(){
      this.xy.loading();
      this.showSelectCon = false
      let res = await this.xyapi.get(
       this.xyMApi+'/vst' + "/visitor/GetVisitorPage",
        {
           KeyWord:this.KeyWord,//关键字查询
           Status: this.interviewType ? this.interviewType :0, //查询状态，查全部传0
           IsMine:1,// 管理员查全部传0，查自己的预约信息传1，教师默认传1
           VisitDate :this.startTime ? this.startTime : '', //访问时间
           PageIndex:this.pageIndex,
           PageSize:this.PageSize
        }
      );
       this.xy.unloading();
      if (res.success) {
        this.xy.unloading();
        // 将新数据与老数据进行合并
        if(res.data === null){
           this.finished = true;
          return
        }
        this.list = this.list.concat(res.data);
        console.log(this.list)
        for(var i = 0;i<this.list.length;i++){
          if(this.list[i].ApprovalStatus === 1 && this.list[i].VisitStatus !== 7){
            this.list[i].visitStatusTxt = '待审批'
          }else if(this.list[i].ApprovalStatus === 2 && this.list[i].VisitStatus === 5){
            this.list[i].visitStatusTxt = '待拜访'
          }else if(this.list[i].ApprovalStatus === 3){
            this.list[i].visitStatusTxt = '已拒绝'
          }else if(this.list[i].ApprovalStatus === 4){
            this.list[i].visitStatusTxt = '已撤销'
          }else if(this.list[i].ApprovalStatus === 2 && this.list[i].VisitStatus === 6){
            this.list[i].visitStatusTxt = '已拜访'
          }else if(this.list[i].VisitStatus === 7){
            this.list[i].visitStatusTxt = '已逾期'
          }
        }
        this.total = res.totalRecords;  //后端传的总条数
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (this.list === null || this.list.length === 0 || this.list.length >= this.total) {
          this.finished = true;
          this.xy.unloading();
           return;
        }
      }
    },
    // 子组件调用
    setCondition(leaveTypeID, applicationState, startTime, interviewType, KeyWord ) {
      console.log(startTime, interviewType, KeyWord)
      this.pageIndex = 1;
      this.startTime = startTime;
      this.interviewType = interviewType;
      this.KeyWord = KeyWord;
      this.list = []
      this.showSelectCon = false;
      if(this.finished){
        this.finished = false;
      }else{
        this.onLoad();
      }
      console.log(this.startTime, this.interviewType, this.KeyWord)
    }
    }
}
</script>
<style lang="less" scoped>
.visitlists{
  .search {
      display: flex;
      background: #fff;
      height: 80px;
      padding: 0 15px;
      .btns {
        flex: 2;
        display: flex;
        color: #505050;
        .search-btn {
          flex: 1;
        }
        .select-btn {
          flex: 1;
        }
      }
    }
  .visitlists-refresh{
    .refreshWrap{
      .visit-list{
        padding: 15px;
        .leave-item {
          background: #fff;
          border-radius: 14px;
          box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
          margin-bottom: 16px;
          padding: 12px 31px 22px 19px;
          .right {
            padding-left: 30px;

            .title {
              display: flex;
              justify-content: space-between;

              .tit {
                flex: 1;
                max-width: 60%;
                font-size: 30px;
                line-height: 64px;
                color: #333;
              }

              .date {
                line-height: 64px;
                color: #b4b4b4;
                font-size: 24px;
              }
            }
          .content{
              color: #666;
              margin-top: 10px;
          }
          .status {
              font-size: 28px;
              margin: 17px 0 0;
              color: #666;
          }
          }
        }
      }
    }
  }
}
.message-info {
  padding: 20px;
  .message-null {
    text-align: center;
    font-size: 28px;
    color: #7f7f7f;
    padding: 12px;
    border-radius: 32px;
    .message-null-img {
      width: 80%;
      margin: 20px auto 60px;
      img {
        width: 100%;
      }
    }
  }
  .index-footer {
    background-color: transparent;
    color: #8989a9;
  }
}
</style>